import { useTranslation } from 'react-i18next'

import { isAppLocale, type AppLocale } from '@/lib/i18n'

export function useNotificationsLocale(): AppLocale {
  const { i18n } = useTranslation()
  return isAppLocale(i18n.language) ? i18n.language : 'it'
}
